import classNames from 'classnames';
import React, { useState } from 'react';
import EligibilityInvalid from '@react/Eligibility/Invalid';
import EligibilitySearch from '@react/Eligibility/Search';
import EligibilityValid from '@react/Eligibility/Valid';
import { useEligibilityContext } from '@react/Eligibility/useEligibilityState';
import useIntersectionObserver from '@react/hooks/useIntersectionObserver';
import useMedia from '@react/hooks/useMedia';
import { useHabitat } from '@react/shared/HabitatContext';
const EligibilityWrapper = () => {
    const [{ hasSelectedEmployer, isValidEmployer, selectedEmployer }] = useEligibilityContext();
    const { illustration } = useHabitat();
    // InView State.
    const [isInView, setInView] = useState(false);
    // Classes.
    const elementClassName = classNames({
        'ec-wrapper': true,
        animated: isInView,
    });
    const responsiveThreshold = useMedia([`(min-width: 768px)`], [0.5], 0.1);
    // Watch for element entering viewport.
    const { elementRef } = useIntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            setInView(true);
        }
    }, { threshold: responsiveThreshold });
    return (React.createElement("section", { ref: elementRef, className: elementClassName },
        illustration && React.createElement("img", { className: "ec-wrapper__image", src: illustration, alt: "" }),
        !hasSelectedEmployer && React.createElement(EligibilitySearch, { key: "search" }),
        hasSelectedEmployer && isValidEmployer && selectedEmployer?.salaryFinanceEmployerDetails && (React.createElement(EligibilityValid, { key: "valid" })),
        hasSelectedEmployer &&
            (!isValidEmployer || !selectedEmployer?.salaryFinanceEmployerDetails) && (React.createElement(EligibilityInvalid, { key: "invalid" }))));
};
export default EligibilityWrapper;
